import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
//TODO: Fix Retention Rate for 2022 should be 69%, but displays 55%. Hardcoded to 69% until cause is found
import { asRoundedPercentage } from "@components/Filters/number.js";
export default {
  filters: {
    asRoundedPercentage
  },
  data() {
    return {};
  },
  computed: {
    cycle() {
      return this.$store.state.cycleId;
    },
    stateSummary() {
      let target = this.$store.getters.stateSummary;
      return target ? target : {};
    },
    edTPAFact() {
      let target = this.stateSummary.Facts.find(x => x.DomainIndicatorId === 5);
      return target ? target : {};
    },
    placementFact() {
      let target = this.stateSummary.Facts.find(x => x.DomainIndicatorId === 9);
      return target ? target : {};
    },
    persistanceFact() {
      let target = this.stateSummary.Facts.find(x => x.DomainIndicatorId === 12);
      return target ? target : {};
    }
  }
};